const staticText = {
  tabLabels: [
    'Signals',
    'Commands',
    'Attributes',
  ],
  userFriendlyScopeMap: {
    control_charge: 'Control charge',
    control_climate: 'Manage climate settings',
    control_ignition: 'Start and stop ignition',
    control_navigation: 'Control navigation',
    control_pin: 'PIN to drive',
    control_security: 'Lock & unlock',
    control_trunk: 'Control trunk',
    read_alerts: 'Vehicle alerts',
    read_battery: 'EV battery level',
    read_charge: 'Charging status',
    read_charge_events: 'Charging events',
    read_charge_locations: 'Charging locations',
    read_charge_records: 'Charging records',
    read_climate: 'Climate status',
    read_compass: 'Compass',
    read_diagnostics: 'Diagnostics',
    read_engine_oil: 'Engine oil life',
    read_extended_vehicle_info: 'Extended vehicle information',
    read_fuel: 'Fuel tank level',
    read_location: 'Location',
    read_odometer: 'Odometer',
    read_security: 'Lock status',
    read_service_history: 'Service history',
    read_speedometer: 'Speedometer',
    read_thermometer: 'Interior & exterior thermometer',
    read_tires: 'Tire pressure',
    read_user_profile: 'Username',
    read_vehicle_info: 'Make, model, year',
    read_vin: 'VIN',
  },
  signals: {
    description: 'Select the vehicle signals your application will collect. This selection defines the permissions vehicle owners must approve. If you change the selected signals later and it requires a new permission, it will apply to new connections moving forward and previous vehicle owners must reauthorize access before your application can collect the newly selected data.',
    selectionColumnLabels: ['Signal', 'Permission'],
  },
  attributes: {
    description: 'Attributes are typically static pieces of data that don’t normally change.',
    selectionColumnLabels: ['Attribute', 'Permission'],
  },
  commands: {
    description: 'Select which actions you wish to control for your vehicles. Vehicle owners will be prompted for these permissions. |+|Learn more@@https://smartcar.com/docs/api-reference/intro|+|',
    selectionColumnLabels: ['Command', 'Permission'],
    commandsList: {
      Commands: [
        {
          displayName: 'Control EV Charge',
          name: 'control_charge',
          permission: 'control_charge',
          type: 'command',
          required: false,
          signalKey: 'Commands.control_charge',
        },
        {
          displayName: 'Control the HVAC temperature',
          name: 'control_climate',
          permission: 'control_climate',
          type: 'command',
          required: false,
        },
        {
          displayName: 'Send a destination to the vehicle\'s navigation',
          name: 'control_navigation',
          permission: 'control_navigation',
          type: 'command',
          required: false,
        },
        {
          displayName: 'Set/Remove a PIN to drive',
          name: 'control_pin',
          permission: 'control_pin',
          type: 'command',
          required: false,
        },
        {
          displayName: 'Lock and Unlock the vehicle doors',
          name: 'control_security',
          permission: 'control_security',
          type: 'command',
          required: false,
        },
        {
          displayName: 'Open and Close the vehicle\'s trunk',
          name: 'control_trunk',
          permission: 'control_trunk',
          type: 'command',
          required: false,
        },
      ],
    },
  },
};

export default staticText;
